import {AbstractControl} from '@angular/forms';

export function numberGreaterThanZeroValidator(control: AbstractControl): { [key: string]: any } | null {
  const value = control.value;

  if (value === null || value === undefined || value === '') {
    return null;
  }
  if (value <= 0) {
    return {numberGreaterThanZero: true};
  } else {
    return null;
  }
}
